import { combineReducers } from 'redux';

import {
    REQUEST_BILLETTERIE_PARTNERS,
    RECEIVE_BILLETTERIE_PARTNERS,
    FAILURE_BILLETTERIE_PARTNERS
} from './constants';

// Une entrée par venue Obiz (plusieurs venues possibles pour un même partnerId)
const venues = (state = [], action) => {
    switch (action.type) {
        case RECEIVE_BILLETTERIE_PARTNERS:
            return action.response.payload || [];
        default:
            return state;
    }
};

// Index des partnerId billetterie, pour reconnaître ces marchands dans les autres référentiels
const partnerIds = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_BILLETTERIE_PARTNERS:
            return (action.response.payload || [])
                .filter(venue => venue.partnerId)
                .reduce((ids, venue) => ({ ...ids, [venue.partnerId]: true }), {});
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_BILLETTERIE_PARTNERS:
            return true;
        case RECEIVE_BILLETTERIE_PARTNERS:
        case FAILURE_BILLETTERIE_PARTNERS:
            return false;
        default:
            return state;
    }
};

const fetched = (state = false, action) => {
    switch (action.type) {
        case RECEIVE_BILLETTERIE_PARTNERS:
            return true;
        default:
            return state;
    }
};

const failed = (state = false, action) => {
    switch (action.type) {
        case FAILURE_BILLETTERIE_PARTNERS:
            return true;
        case REQUEST_BILLETTERIE_PARTNERS:
        case RECEIVE_BILLETTERIE_PARTNERS:
            return false;
        default:
            return state;
    }
};

export default combineReducers({ venues, partnerIds, fetching, fetched, failed });



// WEBPACK FOOTER //
// ./src/services/billetterie/reducer.js